// Styles
import '../scss/index.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/order-full-form';
import './custom/social-proof.js';

jQuery(function () {
  offer.setUsingBilling(true);
  offer.getState(function (data) {
    const currency = offer.getCurrency();
    const expeditedPrice = currency + data.availableShippings[0].fullprice;

    $('#expedited-price').text(expeditedPrice);
  });

  $('select')
    .on('change', function () {
      const $select = $(this);
      if ($select.val() == '') {
        $select.css('color', '#5E5E5E');
      } else {
        $select.css('color', '#000000');
      }
    })
    .change();
});
